import React, { useCallback, useRef, MutableRefObject } from 'react';
import { useAtom } from 'jotai';
import { SearchField } from '@wk/components-v3-react16';
import { moduleFilterAtom } from '../../atoms';
import styles from './ModuleSearch.module.scss';

export const ModuleSearch: React.FC = () => {
  const [searchText, setSearchText] = useAtom(moduleFilterAtom);
  const inputReference = useRef<HTMLInputElement | null>(null);

  const hasClearIcon = searchText.length > 0;

  const handleInput = useCallback(
    (event: React.FormEvent) => {
      const { value } = event.target as HTMLInputElement;
      setSearchText(value);
    },
    [setSearchText]
  );

  const handleClearInput = useCallback(() => {
    setSearchText('');
    if (inputReference.current) {
      inputReference.current.value = '';
      inputReference.current.focus();
    }
  }, [setSearchText]);

  return (
    <div className={styles.searchContainer}>
      <SearchField
        searchButtonId="module-search-button"
        size="medium"
        hasClearIcon={hasClearIcon}
        onClear={handleClearInput}
      >
        <input
          type="search"
          name="module-search"
          aria-labelledby="module-search-button"
          autoComplete="off"
          ref={inputReference}
          onInput={handleInput}
          placeholder="Search by name, version, or description..."
          defaultValue={searchText}
        />
      </SearchField>
    </div>
  );
};
